<script>
  import { locale, isLoading } from 'svelte-i18n';
  import { page } from '$app/stores';
  import { goto } from '$app/navigation';
  
  const languageNames = {
    'en': 'English',
    'es': 'Español',
    'fr': 'Français', 
    'de': 'Deutsch',
    'pt': 'Português',
    'it': 'Italiano',
    'ru': 'Русский',
    'zh': '中文',
    'ja': '日本語',
    'ko': '한국어'
  };
  
  // URL mappings for localized routes
  const localizedUrls = {
    '/secret-santa-generator': {
      'en': '/secret-santa-generator',
      'es': '/es/generador-amigo-secreto',
      'fr': '/fr/generateur-pere-noel-secret',
      'de': '/de/wichtel-generator',
      'pt': '/pt/gerador-amigo-secreto'
    }
  };
  
  function changeLanguage(event) {
    const newLocale = event.target.value;
    locale.set(newLocale);
    
    // Store the preference in localStorage
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('preferred-language', newLocale);
    }
    
    // Check if we're on a page that has localized URLs
    const currentPath = $page.url.pathname;
    
    // Check if current path matches any localized route
    for (const [basePath, urls] of Object.entries(localizedUrls)) {
      // Check if we're on the base path or any of its localized versions
      if (currentPath === basePath || Object.values(urls).includes(currentPath)) {
        // Navigate to the localized URL if it exists
        if (urls[newLocale]) {
          goto(urls[newLocale]);
          return;
        }
      }
    }
    
    // For other pages, just change the locale (no special URL)
  }
</script>

{#if !$isLoading}
  <div class="language-switcher">
    <label for="language-select">🌐</label>
    <select id="language-select" value={$locale} on:change={changeLanguage}>
      {#each Object.entries(languageNames) as [code, name]}
        <option value={code}>{name}</option>
      {/each}
    </select>
  </div>
{/if}

<style>
  .language-switcher {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
  }
  
  label {
    font-size: 1.2rem;
  }
  
  select {
    padding: 0.25rem 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: white;
    cursor: pointer;
    font-size: 0.9rem;
  }
  
  select:focus {
    outline: none;
    border-color: #3498db;
  }
</style>